import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

export function ThemeToggle() {
    const { theme, toggleTheme } = useTheme();
    const isDark = theme === 'dark';

    return (
        <button
            type="button"
            onClick={toggleTheme}
            className="btn btn-secondary flex items-center justify-center w-10 h-10 rounded-full p-0"
            aria-label="Toggle theme"
            title={isDark ? 'Switch to light' : 'Switch to dark'}
        >
            {isDark ? <Sun size={18} /> : <Moon size={18} />}
        </button>
    );
}
